var map = {
	"./arrow-down-blue.svg": 1241,
	"./arrow-down-grey.svg": 1242,
	"./arrow-right-white.png": 1243,
	"./arrow-right.svg": 1244,
	"./big_unicorn.png": 285,
	"./blue-loader.svg": 217,
	"./circle-grey.svg": 1245,
	"./circle.svg": 1246,
	"./coinbaseWalletIcon.svg": 1247,
	"./dropdown-blue.svg": 1248,
	"./dropdown.svg": 1249,
	"./dropup-blue.svg": 1250,
	"./ethereum-logo.png": 1251,
	"./fortmaticIcon.png": 1252,
	"./link.svg": 1253,
	"./logo_dark.png": 1254,
	"./magnifying-glass.svg": 1255,
	"./menu.svg": 1256,
	"./metamask.png": 450,
	"./noise.png": 287,
	"./plus-blue.svg": 1257,
	"./plus-grey.svg": 1258,
	"./png/arrow_icon.png": 218,
	"./png/down.png": 451,
	"./png/loading_logo.png": 288,
	"./png/logo.png": 452,
	"./png/wallet.png": 453,
	"./png/wasp_logo.png": 289,
	"./portisIcon.png": 1259,
	"./question-mark.svg": 1260,
	"./question.svg": 1261,
	"./search.png": 347,
	"./spinner.svg": 1262,
	"./svg/analytics.svg": 1263,
	"./svg/auto_farm.svg": 1264,
	"./svg/bg.svg": 441,
	"./svg/bg_mobile.svg": 442,
	"./svg/bridge.svg": 1265,
	"./svg/conver_wasp.svg": 1266,
	"./svg/docs.svg": 1267,
	"./svg/farming.svg": 1268,
	"./svg/fifa.svg": 1269,
	"./svg/github_logo.svg": 1270,
	"./svg/hive.svg": 1271,
	"./svg/migrate_lp.svg": 1272,
	"./svg/mirror_logo.svg": 1273,
	"./svg/pool.svg": 1274,
	"./svg/slidebar_btn.svg": 1275,
	"./svg/stream_trade.svg": 1276,
	"./svg/swap.svg": 1277,
	"./svg/telegram_logo.svg": 1278,
	"./svg/twitter_logo.svg": 1279,
	"./svg/vote.svg": 1280,
	"./svg/wan_lend.svg": 1281,
	"./svg/zoo.svg": 1282,
	"./token-list/lists-dark.png": 1283,
	"./token-list/lists-light.png": 1284,
	"./token-logo.png": 216,
	"./trustWallet.png": 1285,
	"./walletConnectIcon.svg": 1286,
	"./wanchain-logo.png": 454,
	"./wanmask-logo.png": 449,
	"./wanmask.png": 1287,
	"./wanswap-icon.png": 340,
	"./wanswap-logo.png": 1288,
	"./wanswapv2-icon.png": 603,
	"./x.svg": 1289,
	"./xl_uni.png": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;